// Buildings data - All 100 building definitions and helpers

// 100 BUILDINGS - One unlocks at each level (20 per stage)
export const ALL_BUILDINGS = {
  // STAGE 1 - CAMPSITE (Levels 1-20)
  1: { name: 'Tent', cost: 1, emoji: '⛺', type: 'tent' },
  2: { name: 'Campfire', cost: 1, emoji: '🔥', type: 'campfire' },
  3: { name: 'Pine Tree', cost: 1, emoji: '🌲', type: 'pine' },
  4: { name: 'Oak Tree', cost: 1, emoji: '🌳', type: 'tree' },
  5: { name: 'Bush', cost: 1, emoji: '🌿', type: 'bush' },
  6: { name: 'Flower Bed', cost: 1, emoji: '🌸', type: 'flower' },
  7: { name: 'Rock', cost: 1, emoji: '🪨', type: 'rock' },
  8: { name: 'Log Bench', cost: 2, emoji: '🪵', type: 'bench' },
  9: { name: 'Lantern', cost: 2, emoji: '🏮', type: 'lantern' },
  10: { name: 'Toadstool', cost: 1, emoji: '🍄', type: 'mushroom' },
  11: { name: 'Bird Box', cost: 2, emoji: '🏠', type: 'birdhouse' },
  12: { name: 'Beehive', cost: 3, emoji: '🐝', type: 'beehive' },
  13: { name: 'Pond', cost: 4, emoji: '💧', type: 'pond' },
  14: { name: 'Wooden Sign', cost: 1, emoji: '🪧', type: 'sign' },
  15: { name: 'Hammock', cost: 3, emoji: '🛏️', type: 'hammock' },
  16: { name: 'Fire Ring', cost: 2, emoji: '⭕', type: 'firepit' },
  17: { name: 'Picnic Table', cost: 3, emoji: '🪑', type: 'table' },
  18: { name: 'Cool Box', cost: 2, emoji: '🧊', type: 'cooler' },
  19: { name: 'Fishing Rod', cost: 2, emoji: '🎣', type: 'fishing' },
  20: { name: 'Canoe', cost: 5, emoji: '🛶', type: 'canoe' },
  // STAGE 2 - HAMLET (Levels 21-40)
  21: { name: 'Cottage', cost: 5, emoji: '🏠', type: 'cottage' },
  22: { name: 'Well', cost: 4, emoji: '🪣', type: 'well' },
  23: { name: 'Veggie Patch', cost: 3, emoji: '🥕', type: 'garden' },
  24: { name: 'Wooden Fence', cost: 1, emoji: '🚧', type: 'fence' },
  25: { name: 'Cobble Path', cost: 1, emoji: '🛤️', type: 'path' },
  26: { name: 'Chicken Coop', cost: 5, emoji: '🐔', type: 'coop' },
  27: { name: 'Windmill', cost: 8, emoji: '🏗️', type: 'windmill' },
  28: { name: 'Hay Bale', cost: 1, emoji: '🌾', type: 'hay' },
  29: { name: 'Scarecrow', cost: 3, emoji: '🧑‍🌾', type: 'scarecrow' },
  30: { name: 'Apple Tree', cost: 3, emoji: '🍎', type: 'appletree' },
  31: { name: 'Sunflowers', cost: 2, emoji: '🌻', type: 'beegarden' },
  32: { name: 'Stone Wall', cost: 2, emoji: '🧱', type: 'wall' },
  33: { name: 'Trolley', cost: 4, emoji: '🛒', type: 'trolley' },
  34: { name: 'Barn', cost: 10, emoji: '🏚️', type: 'barn' },
  35: { name: 'Sheep Pen', cost: 6, emoji: '🐑', type: 'sheepPen' },
  36: { name: 'Horse Stable', cost: 8, emoji: '🐴', type: 'stable' },
  37: { name: 'Post Box', cost: 2, emoji: '📬', type: 'mailbox' },
  38: { name: 'Signpost', cost: 1, emoji: '🪧', type: 'signpost' },
  39: { name: 'Bread Oven', cost: 6, emoji: '🥖', type: 'oven' },
  40: { name: 'Water Trough', cost: 3, emoji: '🛁', type: 'trough' },
  // STAGE 3 - VILLAGE (Levels 41-60)
  41: { name: 'House', cost: 8, emoji: '🏡', type: 'house' },
  42: { name: 'Shop', cost: 10, emoji: '🏪', type: 'store' },
  43: { name: 'Chapel', cost: 12, emoji: '⛪', type: 'chapel' },
  44: { name: 'Village Green', cost: 6, emoji: '🌳', type: 'park' },
  45: { name: 'Paved Road', cost: 2, emoji: '🛣️', type: 'road' },
  46: { name: 'Street Lamp', cost: 3, emoji: '💡', type: 'lamp' },
  47: { name: 'Park Bench', cost: 2, emoji: '🪑', type: 'parkBench' },
  48: { name: 'Notice Board', cost: 3, emoji: '📋', type: 'board' },
  49: { name: 'Bakery', cost: 10, emoji: '🥐', type: 'bakery' },
  50: { name: 'Blacksmith', cost: 12, emoji: '⚒️', type: 'blacksmith' },
  51: { name: 'Inn', cost: 14, emoji: '🏨', type: 'inn' },
  52: { name: 'Fountain', cost: 8, emoji: '⛲', type: 'fountain' },
  53: { name: 'Clock Tower', cost: 18, emoji: '🕐', type: 'clockTower' },
  54: { name: 'Flower Stall', cost: 5, emoji: '🌷', type: 'flowerCart' },
  55: { name: 'Bandstand', cost: 10, emoji: '🎪', type: 'gazebo' },
  56: { name: 'Playground', cost: 12, emoji: '🛝', type: 'playground' },
  57: { name: 'Statue', cost: 14, emoji: '🗿', type: 'statue' },
  58: { name: 'Bridge', cost: 10, emoji: '🌉', type: 'bridge' },
  59: { name: 'Fishing Pier', cost: 8, emoji: '🎣', type: 'pier' },
  60: { name: 'Market Stall', cost: 6, emoji: '🏬', type: 'marketStall' },
  // STAGE 4 - TOWN (Levels 61-80)
  61: { name: 'School', cost: 18, emoji: '🏫', type: 'school' },
  62: { name: 'Library', cost: 15, emoji: '📚', type: 'library' },
  63: { name: 'Town Hall', cost: 20, emoji: '🏛️', type: 'townHall' },
  64: { name: 'Grand Fountain', cost: 14, emoji: '⛲', type: 'grandFountain' },
  65: { name: 'Stone Bridge', cost: 15, emoji: '🌉', type: 'stoneBridge' },
  66: { name: 'Fire Station', cost: 18, emoji: '🚒', type: 'fireStation' },
  67: { name: 'Police Station', cost: 18, emoji: '🚔', type: 'policeStation' },
  68: { name: 'Hospital', cost: 22, emoji: '🏥', type: 'hospital' },
  69: { name: 'Post Office', cost: 14, emoji: '🏤', type: 'postOffice' },
  70: { name: 'Bank', cost: 20, emoji: '🏦', type: 'bank' },
  71: { name: 'Restaurant', cost: 15, emoji: '🍽️', type: 'restaurant' },
  72: { name: 'Cinema', cost: 18, emoji: '🎬', type: 'cinema' },
  73: { name: 'Swimming Pool', cost: 18, emoji: '🏊', type: 'pool' },
  74: { name: 'Sports Pitch', cost: 16, emoji: '⚽', type: 'sportsField' },
  75: { name: 'Bus Stop', cost: 8, emoji: '🚏', type: 'busStop' },
  76: { name: 'Car Park', cost: 10, emoji: '🅿️', type: 'parking' },
  77: { name: 'Pet Shop', cost: 14, emoji: '🐕', type: 'petShop' },
  78: { name: 'Toy Shop', cost: 15, emoji: '🧸', type: 'toyShop' },
  79: { name: 'Music Hall', cost: 18, emoji: '🎵', type: 'musicHall' },
  80: { name: 'Art Gallery', cost: 16, emoji: '🎨', type: 'artGallery' },
  // STAGE 5 - CITY (Levels 81-100)
  81: { name: 'Office Tower', cost: 25, emoji: '🏢', type: 'office' },
  82: { name: 'Shopping Centre', cost: 28, emoji: '🏬', type: 'mall' },
  83: { name: 'Monument', cost: 20, emoji: '🗽', type: 'monument' },
  84: { name: 'Stadium', cost: 35, emoji: '🏟️', type: 'stadium' },
  85: { name: 'City Gate', cost: 25, emoji: '🚪', type: 'cityGate' },
  86: { name: 'Airport', cost: 40, emoji: '✈️', type: 'airport' },
  87: { name: 'Railway Station', cost: 30, emoji: '🚂', type: 'trainStation' },
  88: { name: 'University', cost: 35, emoji: '🎓', type: 'university' },
  89: { name: 'Museum', cost: 28, emoji: '🏛️', type: 'museum' },
  90: { name: 'Theatre', cost: 30, emoji: '🎭', type: 'operaHouse' },
  91: { name: 'Skyscraper', cost: 50, emoji: '🏙️', type: 'skyscraper' },
  92: { name: 'Radio Tower', cost: 28, emoji: '📡', type: 'radioTower' },
  93: { name: 'Lighthouse', cost: 24, emoji: '🗼', type: 'lighthouse' },
  94: { name: 'Big Wheel', cost: 35, emoji: '🎡', type: 'ferrisWheel' },
  95: { name: 'Roller Coaster', cost: 40, emoji: '🎢', type: 'rollerCoaster' },
  96: { name: 'Aquarium', cost: 38, emoji: '🐠', type: 'aquarium' },
  97: { name: 'Zoo', cost: 45, emoji: '🦁', type: 'zoo' },
  98: { name: 'Space Centre', cost: 60, emoji: '🚀', type: 'spaceCenter' },
  99: { name: 'Castle', cost: 80, emoji: '🏰', type: 'castle' },
  100: { name: 'Golden Bridge', cost: 100, emoji: '🌟', type: 'goldenBridge' },
};

// Reverse mapping: type string → level number
export const TYPE_TO_LEVEL_MAP = {};
for (const [level, building] of Object.entries(ALL_BUILDINGS)) {
  TYPE_TO_LEVEL_MAP[building.type] = parseInt(level);
}

// Get unlocked buildings based on levels completed
export const getUnlockedBuildings = (levelsCompleted) => {
  const unlocked = [];
  for (const [level, building] of Object.entries(ALL_BUILDINGS)) {
    if (levelsCompleted >= parseInt(level)) {
      unlocked.push({ level: parseInt(level), ...building });
    }
  }
  return unlocked.sort((a, b) => b.level - a.level);
};

// Legacy BUILDINGS object for backward compatibility
export const BUILDINGS = {
  tent: { name: 'Tent', cost: 5, minLevel: 1, icon: '⛺' },
  hut: { name: 'Hut', cost: 10, minLevel: 2, icon: '🛖' },
  house: { name: 'House', cost: 20, minLevel: 3, icon: '🏠' },
  office: { name: 'Office', cost: 30, minLevel: 4, icon: '🏢' },
};
